/* Dark mode */ 
import { tgCommentFunc } from "./telegram-comment-box.js"; 
export const themeSwitchHandler = () => {
    /* Set */
    const setCookie = (name, value, days = 7, path = '/') => {
        const expires = new Date(Date.now() + days * 864e5).toUTCString()
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
    }

    /* Get */
    const getCookie = (name) => {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=')
            return parts[0] === name ? decodeURIComponent(parts[1]) : r
        }, '')
    }

    /* Delete */
    const deleteCookie = (name, path) => {
        setCookie(name, '', -1, path)
    }
    
    function darkMode() {
        let darkmode = getCookie('darkmode');
        if (darkmode == 'enabled') {
            $('body').addClass('dark');
			$('.logo>img').attr('src', 'https://hostpro.ua/logo/logo-fordark.png');
            $('.darkmode').addClass('enabled');
            tgCommentFunc(true);
        } else {
            $('body').removeClass('dark');
			$('.logo>img').attr('src', 'https://hostpro.ua/logo/logo.png');
            $('.darkmode').removeClass('enabled');
            tgCommentFunc();
        }
    };

    darkMode();

    $('.darkmode').on('click', function () {
        if (!$(this).hasClass('enabled')) {
            $('.darkmode').addClass('enabled');
			$('.logo>img').attr('src', 'https://hostpro.ua/logo/logo-fordark.png');
            setCookie('darkmode', 'enabled');
        } else {
            $('.darkmode').removeClass('enabled');
			$('.logo>img').attr('src', 'https://hostpro.ua/logo/logo.png');
            setCookie('darkmode', 'disabled');
        }
        darkMode();
    });
};